"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _vue = _interopRequireDefault(require("vue"));
var _lang = _interopRequireDefault(require("@/lang"));
var _booking = require("@/api/bookSpace/booking");
var state = {
  isToastSavePath: null,
  // 是否是订舱页面，阻止关闭显示提示框进行保存,存得路径
  isToastSave: false,
  // 是否是订舱页面，阻止关闭显示提示框进行保存
  isShowSaveTip: false,
  // 是否显示提示保存信息
  isCloseOpt: false,
  // 是否是标签点击关闭
  // pageForm名称
  watchPageForm: {
    name: '',
    data: '',
    vm: null
  },
  // dialogForm名称
  watchDialogForm: {
    name: '',
    data: ''
  },
  checkQuery: {} //是否需要通告
};
var mutations = {
  /* init page */
  INIT_PAGE_WATCH: function INIT_PAGE_WATCH(state, formObj) {
    state.watchPageForm = formObj;
    state.isCloseOpt = false;
    state.isShowSaveTip = true;
  },
  INIT_DIALOG_WATCH: function INIT_DIALOG_WATCH(state, formObj) {
    state.watchDialogForm = formObj;
  },
  /* 改变 */
  CHANGE_IS_SHOW_SAVE_TIP: function CHANGE_IS_SHOW_SAVE_TIP(state, isShow) {
    state.isShowSaveTip = isShow;
  },
  /* 改变 */
  CHANGE_IS_CLOSE_OPT: function CHANGE_IS_CLOSE_OPT(state, isClose) {
    state.isCloseOpt = isClose;
  },
  /* reset page */
  RESET_PAGE: function RESET_PAGE(state) {
    state.isShowSaveTip = false;
    state.watchPageForm.name = '';
    state.watchPageForm.data = '';
    state.watchPageForm.vm = null;
  },
  REST_DIALOG: function REST_DIALOG(state) {
    state.watchDialogForm.name = '';
    state.watchDialogForm.data = '';
  },
  IS_TOAST_SAVE: function IS_TOAST_SAVE(state, isShow) {
    state.isToastSave = isShow;
  },
  IS_TOAST_SAVE_PATH: function IS_TOAST_SAVE_PATH(state, path) {
    state.isToastSavePath = path;
  },
  CHECK_QUERY: function CHECK_QUERY(state, data) {
    state.checkQuery = data;
  }
};
var actions = {
  // 针对是不是订舱
  isToastSave: function isToastSave(_ref, params) {
    var commit = _ref.commit;
    commit('IS_TOAST_SAVE', params.number);
    commit('IS_TOAST_SAVE_PATH', params.path);
    console.log('isShow', params);
  },
  isShowSaveTip: function isShowSaveTip(_ref2, isShow) {
    var commit = _ref2.commit;
    commit('CHANGE_IS_SHOW_SAVE_TIP', isShow);
  },
  initPageWatch: function initPageWatch(_ref3, formObj) {
    var commit = _ref3.commit;
    formObj.data = JSON.stringify(formObj.data);
    commit('INIT_PAGE_WATCH', formObj);
  },
  initDialogWatch: function initDialogWatch(_ref4, formObj) {
    var commit = _ref4.commit;
    formObj.data = JSON.stringify(formObj.data);
    commit('INIT_DIALOG_WATCH', formObj);
  },
  carryPageWatch: function carryPageWatch(_ref5, form) {
    var state = _ref5.state;
    return new Promise(function (resolve) {
      var flag = false;
      var newFormString = JSON.stringify(form);
      if (state.watchPageForm.data !== newFormString) {
        flag = true;
      }
      resolve(flag);
    });
  },
  carryDialogWatch: function carryDialogWatch(_ref6, form) {
    var state = _ref6.state;
    return new Promise(function (resolve) {
      var flag = false;
      var newFormString = JSON.stringify(form);
      if (state.watchDialogForm.data !== newFormString) {
        flag = true;
      }
      resolve(flag);
    });
  },
  // 数据对比是否有没有更改
  carryWatch: function carryWatch(_ref7, form) {
    var state = _ref7.state;
    return new Promise(function (resolve) {
      var flag = false;
      var newFormString = JSON.stringify(form.newData);
      var oldFormString = JSON.stringify(form.oldData);
      if (oldFormString !== newFormString) {
        flag = true;
      }
      resolve(flag);
    });
  },
  /* 离开页面提示 */savePageTips: function savePageTips(_ref8, next) {
    var commit = _ref8.commit;
    _vue.default.prototype.$confirm(_lang.default.t('tips.saveTip'), _lang.default.t('tips.title'), {
      confirmButtonText: _lang.default.t('tips.submit'),
      cancelButtonText: _lang.default.t('tips.cancel'),
      type: 'warning'
    }).then(function () {
      commit('RESET_PAGE');
      next();
    }).catch(function () {
      next(false);
    });
  },
  /* 关闭页签提示 */saveClosePageTips: function saveClosePageTips(_ref9, closeObj) {
    var commit = _ref9.commit;
    _vue.default.prototype.$confirm(_lang.default.t('tips.saveTip'), _lang.default.t('tips.title'), {
      confirmButtonText: _lang.default.t('tips.submit'),
      cancelButtonText: _lang.default.t('tips.cancel'),
      type: 'warning'
    }).then(function () {
      closeObj.close(closeObj.view);
      commit('RESET_PAGE');
      commit('CHANGE_IS_CLOSE_OPT', true);
    }).catch(function () {});
  },
  /* 关闭弹窗提示保存 */saveDialogTips: function saveDialogTips(_ref10, done) {
    var commit = _ref10.commit;
    _vue.default.prototype.$confirm(_lang.default.t('tips.saveTip'), _lang.default.t('tips.title'), {
      confirmButtonText: _lang.default.t('tips.submit'),
      cancelButtonText: _lang.default.t('tips.cancel'),
      type: 'warning'
    }).then(function () {
      done();
      commit('REST_DIALOG');
    }).catch(function () {});
    // done()
    // commit('REST_DIALOG')
  },
  checkQuery: function checkQuery(_ref11, item) {
    var commit = _ref11.commit;
    return new Promise(function (resolve) {
      (0, _booking.checkQueryNotice)({
        pol: item.pol,
        singleContainerFlag: item.singleContainerFlag
      }).then(function (res) {
        if (res.success) {
          commit('CHECK_QUERY', res.data || {});
          resolve(res.data);
        }
      }).catch(function (err) {
        commit('CHECK_QUERY', {});
      });
    });
  },
  checkPol: function checkPol(_ref12, item) {
    var commit = _ref12.commit;
    return new Promise(function (resolve) {
      (0, _booking.validatePortPermission)(item).then(function (res) {
        if (res.success) {
          resolve(res.data);
        }
      }).catch(function (err) {
        resolve(false);
      });
    });
  },
  // 判断有没有敏感词提示
  checkValidateCargoDesc: function checkValidateCargoDesc(_ref13, item) {
    var commit = _ref13.commit;
    var data = {
      pol: item.pol,
      pod: item.pod,
      cargoDesc: item.cargoDesc
    };
    return new Promise(function (resolve) {
      (0, _booking.validateCargoDesc)(data).then(function (res) {
        if (res.success) {
          if (res.data) {
            _vue.default.prototype.$confirm(_lang.default.t('home.bkNo') + ':' + item.bkNo + ',' + res.data + _lang.default.t('home.cargoDescMessage1'), _lang.default.t('home.saveTip'), {
              confirmButtonText: _lang.default.t('com.yes'),
              cancelButtonText: _lang.default.t('com.no'),
              type: 'warning'
            }).then(function () {
              resolve(true);
            }).then(function () {
              resolve(false);
              //取消操作
            }).catch(function () {
              resolve(false);
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    });
  },
  // 判断附加费杂费
  checkValidateFeeInfo: function () {
    var _checkValidateFeeInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref14, item) {
      var commit, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref14.commit;
            _context.next = 3;
            return (0, _booking.validateFeeInfo)(item);
          case 3:
            res = _context.sent;
            if (!res.success) {
              _context.next = 11;
              break;
            }
            if (!res.data) {
              _context.next = 10;
              break;
            }
            _vue.default.prototype.$confirm(res.data, _lang.default.t('home.failMessage'), {
              confirmButtonText: 'OK',
              closeOnClickModal: false,
              showCancelButton: false,
              // 去掉取消按钮
              type: 'error'
            });
            return _context.abrupt("return", true);
          case 10:
            return _context.abrupt("return", null);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function checkValidateFeeInfo(_x, _x2) {
      return _checkValidateFeeInfo.apply(this, arguments);
    }
    return checkValidateFeeInfo;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};